import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import Image3 from "../assets/images/company/image-3.jpg";

function PrivacyPolicy({ setPageTitle }) {

    useEffect(() => {
        setPageTitle("Privacy Policy - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
            <Helmet>
                <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
                <meta name="title" property="og:title" content={setPageTitle}></meta>
                <meta property="og:type" content="website" />
                <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
                <meta name="image" property="og:image" content={Image3} />
            </Helmet>
            <Navbar />
            <Container className="py-5">
                <Row>
                    <Col lg={8} className="mx-auto">
                        <h1 className="mb-5">Privacy Policy</h1>
                        <p>
                            This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from www.baitalanaqah.com (the “Site”).
                        </p>
                        <h5 className="fw-bold">
                            Personal Information We Collect
                        </h5>
                        <p>
                            When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products you view, what websites or search terms referred you to the Site, and how you interact with the Site. We refer to this automatically collected information as “Device Information”.
                        </p>
                        <h5 className="fw-bold">
                            We collect Device Information using the following technologies:
                        </h5>
                        <p>
                            Cookies: Data files placed on your device or computer that often include an anonymous unique identifier.
                        </p>
                        <p>
                            Log files: Track actions occurring on the Site and collect data, including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.
                        </p>
                        <p>
                            Web beacons, tags, and pixels: Electronic files used to record information about how you browse the Site.
                        </p>
                        <p>
                            Additionally, when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card details processed via Stripe), email address, and phone number. We refer to this information as “Order Information”.
                        </p>
                        <p>
                            When we talk about “Personal Information” in this Privacy Policy, we are referring to both Device Information and Order Information.
                        </p>
                        <h5 className="fw-bold">
                            How do we use your personal information?
                        </h5>
                        <p>
                            We use the Order Information that we collect generally to fulfill orders placed through the Site (including processing your payment information, arranging for shipping via Aramex, and providing you with invoices and/or order confirmations). Additionally, we use this Order Information to:
                            <ul>
                                <li>Communicate with you</li>
                                <li>Screen orders for potential risk or fraud</li>
                                <li>Provide you with information or advertising related to our products or services, in line with your preferences</li>
                            </ul>
                        </p>
                        <p>
                            We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address) and to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site and to assess the success of our marketing and advertising campaigns).
                        </p>
                        <h5 className="fw-bold">
                            Sharing your personal information
                        </h5>
                        <p>
                            We share your Personal Information with third parties to help us use your information as described above. For example:
                        </p>
                        <p>
                            Our store is hosted on cPanel, and we use Google Analytics to understand how our customers use the Site. You can read more about how Google uses your Personal Information here: https://www.google.com/intl/en/policies/privacy/.
                        </p>
                        <p>
                            You can opt out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.
                        </p>
                        <p>
                            Payments are processed securely through Stripe. You can read more about how Stripe handles your Personal Information here: https://stripe.com/privacy.
                        </p>
                        <p>
                            Shipping is handled through Aramex for order fulfillment.
                        </p>
                        <p>
                            We may also share your Personal Information to comply with applicable laws and regulations, respond to a subpoena, search warrant, or other lawful requests for information, or protect our rights.
                        </p>
                        <h5 className="fw-bold">
                            Financial Information
                        </h5>
                        <p>
                            If you choose a direct payment gateway to complete your purchase, all credit card transactions will be processed securely through Stripe. Stripe adheres to the standards set by PCI-DSS (Payment Card Industry Data Security Standard) as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express, and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.
                        </p>
                        <h5 className="fw-bold">
                            Do Not Track
                        </h5>
                        <p>
                        Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.
                        </p>
                        <h5 className="fw-bold">
                            Limitation of Liability
                        </h5>
                        <p>
                        While we take all reasonable steps to protect your information and ensure accurate and secure data processing, we cannot guarantee that unauthorized access, hacking, data loss, or other breaches will never occur. By using our Site, you acknowledge and agree that we are not responsible for any damages resulting from such breaches, except as required by applicable law. Additionally, we are not liable for any errors, interruptions, or failures caused by third-party services we use, such as Stripe, Aramex, or Google Analytics.
                        </p>
                        <h5 className="fw-bold">
                            Your Rights
                        </h5>
                        <p>
                        If you are a resident of the European Economic Area (EEA), you have the right to access the personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us using the details below.
                        </p>
                        <p>
                        Additionally, if you are an EEA resident, we process your information to fulfill contracts we might have with you (e.g., if you make an order through the Site) or otherwise to pursue our legitimate business interests as listed above.
                        </p>
                        <h5 className="fw-bold">
                            Data Retention
                        </h5>
                        <p>
                        When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.
                        </p>
                        <h5 className="fw-bold">
                            Changes
                        </h5>
                        <p>
                        We may update this Privacy Policy from time to time to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.
                        </p>
                        <h5 className="fw-bold">
                            Contact Us
                        </h5>
                        <p>
                        For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by email at info@baitalanaqah.com or by mail at: Bait Al Anaqah Trading Dubai, UAEP.O. Box 33302
                        </p>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default PrivacyPolicy;
